import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "layout-main-container" }
const _hoisted_2 = { class: "layout-main" }
const _hoisted_3 = {
  key: 0,
  class: "layout-mask p-component-overlay"
}


const __default__ = {
  emits: ["change-theme"],
  data() {
    return {
      layoutMode        : "static",
      staticMenuInactive: false,
      overlayMenuActive : false,
      mobileMenuActive  : false,
      menu              : [
        {
          label: "Menu",
          icon : "pi pi-fw pi-search",
          items: [
            { label: "Gate Gallery", icon: "pi pi-fw pi-image", to: "/admin/gateGallery" }
          ]
        }
      ]
    };
  },
  watch   : {
    $route() {
      this.menuActive = false;
      this.$toast.removeAllGroups();
    }
  },
  methods : {
    onWrapperClick() {
      if (!this.menuClick) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }

      this.menuClick = false;
    },
    onMenuToggle() {
      this.menuClick = true;

      if (this.isDesktop()) {
        if (this.layoutMode === "overlay") {
          if (this.mobileMenuActive === true) {
            this.overlayMenuActive = true;
          }

          this.overlayMenuActive = !this.overlayMenuActive;
          this.mobileMenuActive = false;
        } else if (this.layoutMode === "static") {
          this.staticMenuInactive = !this.staticMenuInactive;
        }
      } else {
        this.mobileMenuActive = !this.mobileMenuActive;
      }

      event.preventDefault();
    },
    onSidebarClick() {
      this.menuClick = true;
    },
    onMenuItemClick(event) {
      if (event.item && !event.item.items) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }
    },
    onLayoutChange(layoutMode) {
      this.layoutMode = layoutMode;
    },
    addClass(element, className) {
      if (element.classList) element.classList.add(className);
      else element.className += " " + className;
    },
    removeClass(element, className) {
      if (element.classList) element.classList.remove(className);
      else
        element.className = element.className.replace(
          new RegExp(
            "(^|\\b)" + className.split(" ").join("|") + "(\\b|$)",
            "gi"
          ),
          " "
        );
    },
    isDesktop() {
      return window.innerWidth >= 1200;
    }
  },
  computed: {
    containerClass() {
      return [
        "layout-wrapper",
        {
          "layout-overlay"                : this.layoutMode === "overlay",
          "layout-static"                 : this.layoutMode === "static",
          "layout-static-sidebar-inactive":
            this.staticMenuInactive && this.layoutMode === "static",
          "layout-overlay-sidebar-active" :
            this.overlayMenuActive && this.layoutMode === "overlay",
          "layout-mobile-sidebar-active"  : this.mobileMenuActive,
          "p-input-filled"                : this.$primevue.config.inputStyle === "filled",
          "p-ripple-disabled"             : this.$primevue.config.ripple === false
        }
      ];
    },
    logo() {
      return this.$appState.darkTheme
        ? "images/logo-white.svg"
        : "images/logo.svg";
    }
  },
  beforeUpdate() {
    if (this.mobileMenuActive)
      this.addClass(document.body, "body-overflow-hidden");
    else this.removeClass(document.body, "body-overflow-hidden");
  }
};
import "primevue/resources/primevue.min.css";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import "prismjs/themes/prism-coy.css";
import AdminTopBar from "./AdminTopBar.vue";
import AdminMenu from "./AdminMenu.vue";
import AdminFooter from "./AdminFooter.vue";
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {


return (_ctx, _cache) => {
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.containerClass),
    onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.onWrapperClick && _ctx.onWrapperClick(...args))),
    style: {"font-size":"15px","background-color":"#f5f9ff"}
  }, [
    _createVNode(AdminTopBar, { onMenuToggle: _ctx.onMenuToggle }, null, 8, ["onMenuToggle"]),
    _createElementVNode("div", {
      class: "layout-sidebar",
      onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.onSidebarClick && _ctx.onSidebarClick(...args)))
    }, [
      _createVNode(AdminMenu, {
        model: _ctx.menu,
        onMenuitemClick: _ctx.onMenuItemClick
      }, null, 8, ["model", "onMenuitemClick"])
    ]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_view)
      ]),
      _createVNode(AdminFooter)
    ]),
    _createVNode(_Transition, { name: "layout-mask" }, {
      default: _withCtx(() => [
        (_ctx.mobileMenuActive)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}
}

})